import { Component, Input } from '@angular/core';
import { SpecialtyDistributionItem } from '../../models/insights-dashboard.model';

@Component({
    selector: 'app-ask-ayen-user-distribution',
    templateUrl: './user-distribution.component.html',
    styleUrl: './user-distribution.component.scss',
    standalone: false
})
export class UserDistributionComponent {
  @Input() distribution: SpecialtyDistributionItem[] = [];

  get items() {
    return this.distribution.map((item) => ({
      label: item.name_ar || 'غير محدد',
      count: item.count,
      percentage: item.percentage,
    }));
  }
}
